/** @format */

import {Trans} from 'react-i18next';

import {ROUTES} from 'constants/ROUTES';
import Breadcrumbs from 'components/Breadcrumbs';

interface ChatBreadcrumbsProps {
  companyId: string;
  companyName: string;
}

const ChatBreadcrumbs = ({companyId, companyName}: ChatBreadcrumbsProps) => {
  const breadcrumbs = [
    {
      href: ROUTES.INDEX,
      title: <Trans>Проекты</Trans>,
    },
    {
      href: `/${ROUTES.HOME}`,
      title: companyName,
    },
    {
      href: `/${ROUTES.HOME}/${companyId}/chats`,
      title: <Trans>Чат с AI-агентом</Trans>,
    },
  ];

  return <Breadcrumbs items={breadcrumbs} />;
};

export default ChatBreadcrumbs;
